import React from 'react';
import {Link} from 'react-router-dom';

const ContactPage: React.FC = () => {
  return (
    <div className="mx-auto max-w-4xl px-4 py-8 sm:px-6 lg:px-8 w-full">
      <div className="prose prose-invert max-w-none">
        <h1 className="text-4xl font-bold text-white mb-2">Contact Us</h1>
        <p className="text-gray-400 mb-8">
                    We&apos;d love to hear from you. Get in touch with our support team.
        </p>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-white mb-4">Get in Touch</h2>
          <p className="text-gray-300 leading-relaxed mb-6">
                        Have questions about CensorMe? Need help with your account or subscription? Our support team is here to help.
          </p>
          <p className="text-gray-300 leading-relaxed mb-6">
                        Send us an email at{' '}
            <a
              href="mailto:support@censorme.app"
              className="text-blue-400 hover:text-blue-300 underline transition-colors"
            >
                            support@censorme.app
            </a>
            {' '}and we&apos;ll get back to you as soon as possible.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-white mb-4">What We Can Help With</h2>
          <ul className="list-disc list-inside space-y-2 text-gray-300 ml-6">
            <li>Account and subscription support</li>
            <li>Technical issues with CensorMe</li>
            <li>Questions about features and capabilities</li>
            <li>Billing and payment inquiries</li>
            <li>General feedback and suggestions</li>
          </ul>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-white mb-4">Other Ways to Reach Us</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
                        You can also find answers to common questions in our{' '}
            <Link to="/docs" className="text-blue-400 hover:text-blue-300 underline transition-colors">
                            documentation
            </Link>
                        .
          </p>
        </section>
      </div>
    </div>
  );
};

export default ContactPage;
